/* 全局变量
------------------------------------------------ */
window.$document = $(document);
window.$window = $(window);
window.app = {};



/* 访问终端
------------------------------------------------ */
app.browser = function () {
  var
    u = navigator.userAgent,
    ua = u.toLowerCase();

  var uaMatch = function () {
    var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
      /(webkit)[ \/]([\w.]+)/.exec(ua) ||
      /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
      /(msie) ([\w.]+)/.exec(ua) ||
      ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
    return {
      version: match[2] || "0"
    };
  };
  var p = {
    windows: u.indexOf('Windows') > -1,
    macos: u.indexOf("Mac OS X") > -1,
    linux: u.indexOf("Linux") > -1,
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
    mobile: !!u.match(/AppleWebKit.*Mobile.*/),
  }
  var v = {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    edge: u.indexOf('x`') > -1,
    ie11: u.indexOf('rv:11') > -1,
    ie10: u.indexOf('MSIE 10') > -1,
    iPhone: u.indexOf('iPhone') > -1,
    iPad: u.indexOf('iPad') > -1,
    weixin: u.indexOf('MicroMessenger') > -1,
    qq: u.match(/\sQQ/i) == 'qq'
  }
  v.ieHigh = v.edge || v.ie11 || v.ie10;
  return {
    platform: p,
    versions: v,
    version: uaMatch().version,
    isTouch: ("ontouchstart" in window) || (ua.indexOf( "touch" ) !== -1) || (ua.indexOf( "mobile" ) !== -1),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  };
}();


/* 获取设备宽高
------------------------------------------------ */
$window.resize(function () {
  var p = app.browser.platform,
    v = app.browser.versions;
  app.screen = {
    vw: window.innerWidth,
    vh: window.innerHeight
  };
  app.device = {
    mobile: app.screen.vw < 768,
    pad_v: app.screen.vw >= 768 && app.screen.vw < 1024,
    pad_h: (app.screen.vw > 768 && app.screen.vw <= 1366) && (p.android || v.iPad),
    desktop: app.screen.vw >= 1024 && !p.android && !v.iPad
  };
}).resize();


/* 修改日志[方法]
------------------------------------------------ */
app.debug = false;
app.log = function(msg) {
  app.debug && console.log(msg)
};



/* 延时[方法]，执行一个事件，重复进入会clear上一次的timeout
------------------------------------------------ */
app.timeout = function (flag, callback, time) {
  var tim_handle = flag + '_timeout';
  if (window[tim_handle]) {
    clearTimeout(window[tim_handle]);
  }
  window[tim_handle] = setTimeout(function () {
    callback();
  }, time || 1000);
};


/* 动态加载JS/CSS[方法]
------------------------------------------------ */
app.loadFile = function (opt) {
  var options = {
    type : 'js',
    url : '',
    loadCallback : function() {
      app.log('加载完毕回调');
    }
  }
  options = $.extend(options, opt);
  if (options.type == 'js') {
    var file = document.createElement('script');
    file.src = options.url;
  } else if (options.type == 'css') {
    var file = document.createElement('link');
    file.rel = 'stylesheet';
    file.href = options.url;
  } else if (options.type == 'style') {
    var file = document.createElement('style');
    file.rel = 'stylesheet';
    file.innerHTML = options.style;
  }
  document.getElementsByTagName('head')[0].appendChild(file);
  file.onload = function() {
    options.loadCallback();
  }
};


/* 检查css支持[方法]
------------------------------------------------ */
app.cssSupport = function (attr, value, addClass) {
  var element = document.createElement('div');
  var notSupport = function () {
    app.log('css不支持' + attr + ':' + value);
    addClass && $html.addClass('no-' + value);
    return false;
  }
  if (attr in element.style) {
    element.style[attr] = value;
    if (element.style[attr] != value) {
      notSupport();
    } else {
      return true;
    }
  } else {
    notSupport();
  }
}


/* 转治手持设备防止拖拽出现bug[方法]
------------------------------------------------ */
app.m = {
  // ios禁用放大（拖拽，双击）
  iosDisZoom: function () {
    if (app.browser.platform.ios) return;
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, {
      passive: false
    });
    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (event) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, {
      passive: false
    });
  }
}


/* html浏览器标示
------------------------------------------------ */
app.addBrowserTag = {
  versions: function () {
    var versions = app.browser.versions
    for (key in versions) {
      versions[key] && $html.addClass('versions_' + key);
    }
  },
  platform: function () {
    var platform = app.browser.platform
    for (key in platform) {
      platform[key] && $html.addClass('platform_' + key);
    }
  },
  isTouch: function () {
    if (app.browser.isTouch) {
      $html.addClass('is-touch')
    } else {
      $html.addClass('no-touch')
    }
  },
  language: function () {
    $html.addClass(app.browser.language);
  },
  cssSupport: function () {
    var css = {
      'position': 'sticky',
    }
    for (key in css) {
      app.cssSupport(key, css[key], true);
    }
  },
  scrollWidth: function () {
    $html.addClass('scroll_' + app.scroll.width);
  }
}



// readay执行
$(function () {
  // 全局变量
  window.$html = $('html');
  window.$body = $('body');
  
  /* 滚动条宽度
  ------------------------------------------------ */
  app.scroll = {
    width: function () {
      oDiv = document.createElement('div');
      oDiv.style.cssText = 'position:absolute;box-sizing:content-box;width:100px;height:100px;overflow:hidden;';
      var noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = 'scroll';
      var scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      // document.body.addClass('aaa');
      return noScroll - scroll;
    }()
  }
});



/* 响应式common
------------------------------------------------ */
app.response = function () {
  var callback = app.response.callback;
  var fn = {
    desktop: function () {
      if ($html.hasClass('is_desktop')) return;
      $html.addClass('is_desktop');
      callback.desktop && callback.desktop();
    },
    padH: function () {
      if ($html.hasClass('is_pad_h')) return;
      $html.addClass('is_pad_h');
      callback.padH && callback.padH();
    },
    padV: function () {
      if ($html.hasClass('is_pad_v')) return;
      $html.addClass('is_pad_v');
      callback.padV && callback.padV();
    },
    mobile: function () {
      if ($html.hasClass('is_mobile')) return;
      $html.addClass('is_mobile');
      callback.mobile && callback.mobile();
    }
  }
  callback.all && callback.all();
  $window.resize(function () {
    app.device.mobile ? fn.mobile() : $html.removeClass('is_mobile');
    app.device.pad_v ? fn.padV() : $html.removeClass('is_pad_v');
    app.device.pad_h ? fn.padH() : $html.removeClass('is_pad_h');
    app.device.desktop ? fn.desktop() : $html.removeClass('is_desktop');
  }).resize();
}


/* 初始化页面加载的方法
------------------------------------------------ */
app.pageInit = function () {
  app.response();
  app.addBrowserTag.platform();
  app.addBrowserTag.versions();
  app.addBrowserTag.isTouch();
  app.addBrowserTag.cssSupport();
  app.addBrowserTag.scrollWidth();
  // app.addBrowserTag.language();
  app.m.iosDisZoom();
}





/* $.fn扩展
------------------------------------------------ */
//元素位置回调
$.fn.position_callback = function (opt) {
  var selector = this.selector;
  $(this).each(function () {
    var $this = $(this);
    if (!$this.length) {
      console.log('元素 ' + selector + ' 未找到');
      return;
    }
    var ele = $this[0];
    var options = {
      offsetTop: 0,
      offsetBottom: 0,
      topUp: function () {},
      topDown: function () {},
      bottomUp: function () {},
      bottomDown: function () {}
    };
    options = $.extend(options, opt);
    var scroll_position_callback = '';
    var scroll_position_callback_flag = 'scroll_position_callback_' + (selector + '').replace(/[^a-zA-Z\d]/g, '_');
    if (!$this.data(scroll_position_callback_flag)) {
      var position_callback_uuid_count = $('body').data('position_callback_uuid_count');
      if (!position_callback_uuid_count) position_callback_uuid_count = 0;

      $('body').data('position_callback_uuid_count', ++position_callback_uuid_count);
      $this.data(scroll_position_callback_flag, scroll_position_callback_flag + '_' + position_callback_uuid_count);
    }
    scroll_position_callback = $this.data(scroll_position_callback_flag);
    var status;
    $(window).off('scroll.' + scroll_position_callback).on('scroll.' + scroll_position_callback, function () {
      if (ele.getBoundingClientRect().top < options.offsetTop) {
        if (!status || status == 'topDown') {
          status = 'topUp';
          options.topUp.call($this);
        }
      } else {
        if (status == 'topUp' || status == 'bottomDown') {
          status = 'topDown';
          options.topDown.call($this);
        }
      }
      if (ele.getBoundingClientRect().bottom < options.offsetBottom) {
        if (status == 'topUp' || status == 'bottomDown') {
          status = 'bottomUp';
          options.bottomUp.call($this);
        }
      } else {
        if (status == 'bottomUp') {
          status = 'bottomDown';
          options.bottomDown.call($this);
        }
      }
    });
  });
}

//计算内部元素高度
$.fn.childHeight = function (callback) {
  var h = 0;
  this.children().each(function () {
    h += $(this).height();
  });
  callback && callback();
  return h;
}

// 带margin
$.fn.childAllHeight = function (callback) {
  var h = 0;
  this.children().each(function () {
    h += $(this).outerHeight(true);
  });
  callback && callback();
  return h;
}
